"use client";

import NextLink from "next/link";
import type { ComponentProps } from "react";
import { useTranslation } from "@/lib/i18n";
import { localizeHref } from "@/lib/localize-href";

/**
 * Drop-in replacement for next/link that keeps Bulgarian pages linking to
 * Bulgarian URLs. Pages are prerendered per language, so the /bg/ prefix is
 * already in the static HTML that crawlers and visitors receive.
 */
export default function Link({ href, ...props }: ComponentProps<typeof NextLink>) {
  const { language } = useTranslation();
  const localized = typeof href === "string" ? localizeHref(href, language) : href;
  return <NextLink href={localized} {...props} />;
}
